import { AiOutlineHome } from 'react-icons/ai';

export default function PageError() {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white text-center px-4">
      <h1 className="text-6xl mobile:text-[38px] text-nowrap text-MainColor mb-8 Pretendard-Bold">Page Not Found</h1>
      <h3 className="text-lg mobile:text-sm Pretendard-Bold text-[#141414] mb-4">
        죄송합니다. 요청하신 페이지를 찾을 수 없습니다.
      </h3>
      <p className="text-[#afafaf] mobile:text-xs mobile:leading-5  mb-8 Pretendard-Regular leading-relaxed">
        존재하지 않는 주소를 입력하셨거나, <br /> 요청하신 페이지의 주소가 변경되었거나 삭제되었습니다.
      </p>
      <button
        onClick={handleGoHome}
        className="flex items-center space-x-2 px-6 py-3 bg-MainColor text-white font-medium rounded-lg hover:bg-[#03c9b8] transition duration-300"
      >
        <AiOutlineHome className="text-xl" />
        <span>홈으로 돌아가기</span>
      </button>
    </div>
  );
}
